import React from "react";
import { ArrowRightIcon, GiftIcon } from "lucide-react";
import { bonuses, book } from "../data/book";
import { BookCover } from "./BookCover";
export function PreorderSection() {
  return <section id="preorder" className="scroll-mt-20 border-y border-line bg-night py-24 lg:py-32" data-id="element-119" data-mp="3qjexuq4rvff2">
      <div className="mx-auto grid max-w-6xl items-center gap-16 px-6 lg:grid-cols-[0.8fr_1.2fr] lg:px-10" data-id="element-120" data-mp="3miblidlxo1il">
        <div className="hidden lg:block" data-id="element-121" data-mp="2yrz328t2amdr">
          <div className="mx-auto max-w-[320px]" data-id="element-122" data-mp="2ysqz1kqkmm4k">
            <BookCover data-id="element-123" data-mp="2ttxj7lntaj18" />
          </div>
        </div>

        <div className="max-w-xl" data-id="element-124" data-mp="2tv8m7j9fnmra">
          <h2 className="font-display text-4xl text-cream sm:text-5xl" data-id="element-125" data-mp="37sxa6zysra0k">Join our Launch List</h2>
          <p className="mt-3 text-lg text-muted" data-id="element-126" data-mp="32uc6uro90a7w">
            Out {book.releaseDate}. Pre-order today and you’ll get:
          </p>

          <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-127" data-mp="n1wsqqgdwmic">
            {bonuses.map(bonus => <li key={bonus} className="flex items-center gap-4 py-4 text-lg text-cream/90" data-id="element-128" data-mp="i2tm51kra889">
                <GiftIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-129" data-mp="2cguvk72mra3o" />
                {bonus}
              </li>)}
          </ul>

          <a href={book.preorderUrl} target="_blank" rel="noopener noreferrer" className="group mt-10 flex w-full items-center justify-center gap-3 rounded-lg bg-gold px-8 py-5 text-lg font-bold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-night" data-id="element-130" data-mp="2gjrha6ngvmbu">
            Pre-order now
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-131" data-mp="22q05ssq6dsdh" />
          </a>
        </div>
      </div>
    </section>;
}